import React from 'react';
import Email from '../../assets/icons/email.png';
import Github from '../../assets/icons/github.svg';
import Codepen from '../../assets/icons/codepen.svg';
import LinkedIn from '../../assets/icons/linkedin.svg';

const Contact = props => (
  <div className="contact">
    <h2>Want to find out more?</h2>
    <div className="contact-grid">
      <a href="mailto: trevans24@gmail.com">
        <img src={Email} alt="email" className="email" />
      </a>
      <a href="https://github.com/trevans24" target="_blank" rel="noopener noreferrer">
        <img src={Github} alt="github" className="github" />
      </a>
      <a href="https://codepen.io/trevans24/" target="_blank" rel="noopener noreferrer">
        <img src={Codepen} alt="codepen" className="codepen" />
      </a>
      <a href="https://www.linkedin.com/in/troy-evans24/" target="_blank" rel="noopener noreferrer">
        <img src={LinkedIn} alt="linkedin" className="linkedin" />
      </a>
    </div>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/home/Contact.js